import { render } from "./Home.vue?vue&type=template&id=084b0166&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=084b0166&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-084b0166"

export default script